module.exports = __webpack_public_path__ + "img/zoushi1.b3bbf6a5.png";